export const isNumberOnly = (v?: string) => !!v?.match(/^[0-9]+$/);
